/**
 * Restaurants Flavor Module
 *
 * Provides the restaurant experience: menu search, menu item cards,
 * order management, and media gallery for dish photos and ambiance.
 *
 * Extends BaseFlavor — all universal handlers (show_items, cart_updated,
 * show_media, dismiss_media) are wired automatically.
 */
import { BaseFlavor } from './BaseFlavor.js';
import { RestaurantManager } from '../restaurants/RestaurantManager.js';

class RestaurantsFlavor extends BaseFlavor {
  createManager({ shadowRoot, primaryColor }) {
    return new RestaurantManager({
      shadowRoot,
      primaryColor,
      onItemSelected: (item) => this.handleItemSelected(item),
    });
  }

  getManagerHideMethod() {
    return 'hideMenuItems';
  }
}

export function createRestaurantsFlavor(widget, flavor = {}) {
  return new RestaurantsFlavor(widget, flavor);
}
